import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-call-rejected-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfCallRejectedIconProps extends SvgIconProps{}

/**
 * Component displays Rejected svg icon 
 * @param props -CcfCallRejectedIconProps
 * @returns rejected svg rejected icon
 * @example - <CcfCallRejectedIcon/>
 */
export function CcfCallRejectedIcon(props: CcfCallRejectedIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Call_Rejected" data-name="Call Rejected">
        <path id="status-rejected" d="M23.875,4.05A13.822,13.822,0,0,0,13.96,0,13.822,13.822,0,0,0,4.045,4.05a14.076,14.076,0,0,0,0,19.83,13.822,13.822,0,0,0,9.915,4.05,13.822,13.822,0,0,0,9.915-4.05,14.076,14.076,0,0,0,0-19.83ZM21.92,6a11.286,11.286,0,0,1,.978,14.8L7.117,5.167A11.006,11.006,0,0,1,13.96,2.793,11.556,11.556,0,0,1,21.92,6ZM6,21.925a11.283,11.283,0,0,1-.838-14.8L20.8,22.763a11.006,11.006,0,0,1-6.843,2.374A11.556,11.556,0,0,1,6,21.925Z" transform="translate(3.039 3.105)"/>
      </g>
    </SvgIcon>
  );
}

export default CcfCallRejectedIcon;
